const { Fragment, useState, useEffect, useRef } = wp.element;
const { RichText } = wp.blockEditor;
import { __ } from "@wordpress/i18n";

const Preview = ({ attributes, clientId, setAttributes, isSelected, isPreset = false }) => {
  const exampleFile = "http://localhost/freemius/wp-content/uploads/2022/02/temp.pdf";
  const {
    uniqueId = `pdfpnewId`,
    file = pdfp?.placeholder || exampleFile,
    title,
    titleFontSize,
    height,
    width,
    showName,
    print,
    onlyPDF,
    downloadButton,
    downloadButtonText,
    fullscreenButton,
    fullscreenButtonText,
    protect,
    thumbMenu,
    hrScroll,
    initialPage,
    zoomLevel,
    additional,
    adobeEmbedder,
    adobeOptions,
    align,
    popupBtnStyle,
    CSS,
    popupBtnText,
  } = attributes;

  const adobeRef = useRef();

  useEffect(() => {
    if (!adobeEmbedder && adobeRef.current) {
      adobeRef.current.innerHTML = "";
    }

    if (adobeRef?.current && adobeOptions.embedMode != "LIGHT_BOX") {
      renderPDF();
    }
  }, [adobeOptions, adobeEmbedder, file]);

  useEffect(() => {
    if (document.getElementById(uniqueId)) {
      document.getElementById(uniqueId).style.height = height;
    }
  }, [adobeOptions.embedMode]);

  const renderPDF = () => {
    if (typeof AdobeDC != "undefined") {
      var adobeDCView = new AdobeDC.View({ clientId: fpdfAdmin?.adobeClientKey, divId: uniqueId });
      adobeDCView.previewFile(
        {
          content: { location: { url: file } },
          metaData: { fileName: title || " " },
        },
        adobeOptions
      );
    }
  };

  let source = "";

  if (file.includes(window.location.origin)) {
    let zoom = "&z=auto";
    if (zoomLevel) {
      zoom = `&z=${zoomLevel / 100}`;
    }
    const viewer = onlyPDF ? "raw/raw.html" : protect ? "web/pviewer.html" : "web/viewer.html";
    source = `${pdfp?.dir}pdfjs-new/${viewer}?file=${file}${zoom}&nobaki=${!protect && downloadButton ? "vera" : "false"}&stdono=${
      print && !protect ? "vera" : "false"
    }&open=false&onlypdf=${onlyPDF ? "vera" : "false"}&hrscroll=${hrScroll ? "vera" : "false"}&side=${thumbMenu}#page=${initialPage}`;
  } else if (file.includes(".google.com")) {
    source = file;
  }

  useEffect(() => {
    let CSS = `.${uniqueId}btn {background: ${popupBtnStyle?.background}; color: ${popupBtnStyle?.color}; padding: ${popupBtnStyle?.padding?.top}px ${popupBtnStyle?.padding?.right}px ${popupBtnStyle?.padding?.bottom}px ${popupBtnStyle?.padding?.left}px}`;
    setAttributes({ CSS });
  }, [popupBtnStyle, uniqueId, height]);

  return (
    <div>
      {adobeEmbedder ? (
        <>
          {fpdfAdmin?.adobeClientKey ? (
            <div
              className="pdfp_editor_wrapper pdfp_wrapper"
              ref={adobeRef}
              style={{ width: `${adobeOptions?.embedMode === "LIGHT_BOX" ? "fit-content" : width} ` }}
              data-align={align}
            >
              {!isSelected ? <div style={{ width: "100%", height: "100%", position: "absolute", top: 0, left: 0, minHeight: "400px" }}></div> : ""}
              {adobeOptions?.embedMode === "LIGHT_BOX" ? (
                <>
                  <style>{CSS}</style>
                  <button
                    className={`${uniqueId}btn`}
                    onClick={() => {
                      !isPreset && renderPDF();
                    }}
                  >
                    {popupBtnText || file?.split(".").slice(0, -1).join(".")}
                  </button>
                </>
              ) : (
                <div id={uniqueId} style={{ height }}></div>
              )}
            </div>
          ) : (
            <div style={{ padding: "20px", border: "1px solid #ddd" }}>
              <h2>{__("Adobe Client Key Required to use Adobe Embedder", "pdfp")}</h2>

              <a className="button button-primary" target="_blank" href={`${pdfp?.siteUrl}/wp-admin/edit.php?post_type=pdfposter&page=fpdf-settings#tab=cloud-api`}>
                {__("Generate Client key", "pdfp")}
              </a>
            </div>
          )}
        </>
      ) : (
        <>
          <div className={`pdfp_wrapper ${isSelected && "pdfp_editor_wrapper"} ${additional.Class}`} style={{ width }}>
            {showName && !isPreset && (
              <RichText
                tagName="p"
                value={title}
                allowedFormats={[]}
                style={{ fontSize: titleFontSize, margin: "20px" }}
                onChange={(title) => setAttributes({ title })}
                placeholder={__("Title", "pdfp")}
              />
            )}

            {file.includes("dropbox.com") ? (
              <div style={{ border: "2px solid #ddd" }}>
                <p>{file}</p>
                <p>{__("Preview is not available for dropbox", "pdfp")}</p>
              </div>
            ) : (
              <Fragment>
                <div className="cta_wrapper">
                  {downloadButton && !protect && (
                    <a className="pdfp_download" onClick={(e) => e.preventDefault()} download href={file}>
                      <button className="pdfp_download_btn">{downloadButtonText}</button>
                    </a>
                  )}

                  {fullscreenButton && !protect && (
                    <a href={source} onClick={(e) => e.preventDefault()} target="_blank">
                      <button>{fullscreenButtonText}</button>
                    </a>
                  )}
                </div>

                <div className="iframe_wrapper">
                  <div className="pdfp_frame_overlay"></div>
                  <iframe className="pdfp_iframe" height={height} style={{ height }} src={source}></iframe>
                </div>
              </Fragment>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Preview;
